export default "__VITE_ASSET__Cz5aLbE2__"